'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIButton from 'UIComponents/button/UIButton';
import H1 from 'UIComponents/elements/headings/H1';
import UIImage from 'UIComponents/image/UIImage';
import Branding from 'MeetingsBase/models/Branding';
import { getPrimaryButtonStyle, getPrimaryButtonHoverStyle } from 'MeetingsLib/utils/color';
import BookingFormField from 'MeetingsLib/components/input/BookingFormField';
import EmailAddressPattern from 'PatternValidationJS/patterns/EmailAddress';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import { fetchPublicAvailabilityInfoForOwner as fetchBookInfoForOwner } from 'MeetingsLib/redux/actions/BookActions';
import PreviewContext from 'MeetingsLib/utils/PreviewContext';
import CompanyLogo from 'MeetingsLib/components/decorative/CompanyLogo';
var EmailForm = createReactClass({
  displayName: "EmailForm",
  propTypes: {
    compact: PropTypes.bool,
    logoUrl: PropTypes.string,
    useCompanyLogo: PropTypes.bool,
    title: PropTypes.string,
    description: PropTypes.string,
    setEmailForm: PropTypes.func.isRequired,
    fetchPublicAvailabilityInfoForOwner: PropTypes.func.isRequired,
    branding: PropTypes.instanceOf(Branding).isRequired,
    EmailFormMarker: PropTypes.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      email: '',
      buttonHover: false
    };
  },
  getEmailIsValid: function getEmailIsValid() {
    var email = this.state.email;
    return Boolean(email && EmailAddressPattern.test(email));
  },
  onEmailChange: function onEmailChange(fieldName, email) {
    this.setState({
      email: email
    });
  },
  onMouseEnter: function onMouseEnter() {
    this.setState({
      buttonHover: true
    });
  },
  onMouseLeave: function onMouseLeave() {
    this.setState({
      buttonHover: false
    });
  },
  getValidation: function getValidation() {
    if (this.getEmailIsValid()) {
      return false;
    }

    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "prebook.details.errorHelper.email"
    });
  },
  getClassNames: function getClassNames() {
    return 'email-form height-100 p-all-5' + (this.props.compact ? " compact" : "");
  },
  handleEmailSubmit: function handleEmailSubmit(e) {
    e.preventDefault();
    var email = this.state.email;
    var _this$props = this.props,
        setEmailForm = _this$props.setEmailForm,
        fetchPublicAvailabilityInfoForOwner = _this$props.fetchPublicAvailabilityInfoForOwner;
    setEmailForm(email);
    fetchPublicAvailabilityInfoForOwner({
      email: email
    });
  },
  renderButton: function renderButton() {
    var _this = this;

    var primaryColor = this.props.branding.primaryColor;
    var style = this.state.buttonHover ? getPrimaryButtonHoverStyle(primaryColor) : getPrimaryButtonStyle(primaryColor);
    var isValid = this.getEmailIsValid();
    return /*#__PURE__*/_jsx("div", {
      className: "text-center m-top-5",
      children: /*#__PURE__*/_jsx(PreviewContext.Consumer, {
        children: function children(isPreview) {
          return /*#__PURE__*/_jsx(UIButton, {
            style: style,
            use: "primary",
            disabled: !isValid,
            onClick: !isPreview && _this.handleEmailSubmit,
            size: "medium",
            onMouseEnter: _this.onMouseEnter,
            onMouseLeave: _this.onMouseLeave,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "emailForm.button"
            })
          });
        }
      })
    });
  },
  renderAvatar: function renderAvatar() {
    var _this$props2 = this.props,
        useCompanyLogo = _this$props2.useCompanyLogo,
        logoUrl = _this$props2.logoUrl,
        branding = _this$props2.branding;

    if (!useCompanyLogo && !logoUrl) {
      return /*#__PURE__*/_jsx(UIIllustration, {
        name: "meetings",
        width: "60%"
      });
    } else if (useCompanyLogo) {
      return /*#__PURE__*/_jsx("div", {
        className: "text-center m-top-4 m-x-14",
        children: /*#__PURE__*/_jsx(CompanyLogo, {
          branding: branding,
          use: 'email-form',
          heightOverride: "200px"
        })
      });
    } else {
      return /*#__PURE__*/_jsx("div", {
        className: "text-center m-top-4",
        children: /*#__PURE__*/_jsx(UIImage, {
          src: logoUrl,
          shape: "circle",
          style: {
            width: '200px',
            height: '200px',
            margin: 'auto'
          }
        })
      });
    }
  },
  render: function render() {
    var _this$props3 = this.props,
        primaryColor = _this$props3.branding.primaryColor,
        title = _this$props3.title,
        description = _this$props3.description,
        EmailFormMarker = _this$props3.EmailFormMarker;
    var classes = this.getClassNames();
    var color = primaryColor;

    var fieldLabel = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "emailForm.placeholder"
    });

    return /*#__PURE__*/_jsx(UIFlex, {
      justify: "around",
      className: classes,
      style: {
        borderColor: color
      },
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          maxWidth: '350px'
        },
        children: [/*#__PURE__*/_jsxs("div", {
          className: "text-center m-top-4",
          children: [this.renderAvatar(), /*#__PURE__*/_jsx(H1, {
            className: "m-y-2",
            children: title || /*#__PURE__*/_jsx(FormattedMessage, {
              message: "emailForm.header"
            })
          }), /*#__PURE__*/_jsx("p", {
            className: "m-bottom-4",
            children: description || /*#__PURE__*/_jsx(FormattedMessage, {
              message: "emailForm.text"
            })
          })]
        }), /*#__PURE__*/_jsx(BookingFormField, {
          fieldName: "email",
          fieldLabel: fieldLabel,
          validation: this.getValidation(),
          fieldValue: this.state.email,
          isRequired: true,
          setFormValue: this.onEmailChange,
          autocomplete: "on"
        }), this.renderButton(), /*#__PURE__*/_jsx(EmailFormMarker, {})]
      })
    });
  }
});
export default connect(function () {
  return {};
}, Object.assign({}, FormActions, {
  fetchPublicAvailabilityInfoForOwner: fetchBookInfoForOwner
}))(EmailForm);